import { AdminPageContent, AdminPageHeader } from "@/components/admin";
import { useBreadcrumb } from "@/contexts/shared/breadcrumb";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";
import { useMountEffect } from "@react-hookz/web";
import { FieldsAccordionView } from "./components/FieldsAccordionView";

const AdminFields = () => {
    const { setBreadcrumbs } = useBreadcrumb();

    useDocumentTitle("Fields");

    useMountEffect(() => {
        setBreadcrumbs([{ label: "Admin", path: "home" }, { label: "Fields" }]);
    });

    return (
        <AdminPageContent>
            <AdminPageHeader
                title="Fields"
                subtitle="Browse field definitions organized by category"
            />

            <div className="mt-6">
                <FieldsAccordionView />
            </div>
        </AdminPageContent>
    );
};

export default AdminFields;
